module.exports = __webpack_public_path__ + "img/food_recommendation.e41088ec.png";